import template from './drawer.html';

interface DrawerControllerProps {
  /**
   * set during link step
   */
  $el: JQLite;
  loading: boolean;
  open: boolean;
  setRef: (props: { context: { $el: JQLite | null } }) => void;
  close: () => void;
}

export const drawerDirective: angular.IDirectiveFactory = () => {
  return {
    restrict: 'E',
    transclude: true,
    controller: DrawerController,
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      loading: '=?',
      open: '=?',
      noTopBar: '=?',
      close: '&?onClose',
      setRef: '&?ref',
    },
    template,
    link: ($scope, $el, attrs, vm: DrawerControllerProps) => {
      vm.$el = $el;

      $scope.$on('$destroy', () => {
        vm.setRef({ context: { $el: null } });

        $el.remove();
      });

      // we need to render inside body to ensure that drawer will be the top layer
      $el.appendTo('body');

      // notify directive owner about drawer $el
      vm.setRef({ context: { $el } });
    },
  };
};

function DrawerController(this: DrawerControllerProps) {
  const vm = this;

  if (!vm.loading) {
    vm.loading = false;
  }

  if (typeof vm.open !== 'boolean') {
    vm.open = true;
  }
}
